import {forwardRef} from "react";

type FullWidthSidebarType = {
    navigationComponent?: any;
    extraClass?: string;
    extraContentClass?: string;
    children?: any;
}

const FullWidthSidebar = forwardRef((props: FullWidthSidebarType, ref: any) => {
    return (
        <div className={`inner-sidebar-content-layout ${props.extraClass}`}>
            {props.navigationComponent && props.navigationComponent}
            <div className={`content-main item-contents  ${props.extraContentClass}`} ref={ref}>
                {props.children}
            </div>
        </div>
    )
})

export default FullWidthSidebar